module.exports = __webpack_public_path__ + "static/media/microsoftstudentambassador.f90fb971.png";